<template>
  <v-container class="page-content px-5" style="width: 100%">
    <v-card>
      <v-toolbar
        class="removeBtnPaddingRight rounded-t-lg"
        color="#DADADA"
        flat
        dense
      >
        <v-btn
          @click="returnParent()" class="ml-n1 black--text" icon small
        >
          <v-icon>arrow_back</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="pa-0">
        <RoleLogList></RoleLogList>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>

import TitledPageMixin from "@/mixins/TitledPageMixin";
import names from "@/modules/admin/routers/names";
import admin from "@/urls/roles/admin";
import names_core from "@/modules/core/routers/names";
import RoleLogList from "@/modules/admin/roles/components/RoleLogList";
import {mapActions, mapGetters} from "vuex";

export default {
  name: "AdminRolesLog",
  components: { RoleLogList },
  mixins: [TitledPageMixin],
  data() {
    return {
      user_name: null,
      page_title: "Список операций по роли"
    }
  },
  watch: {},
  computed: {
    ...mapGetters({
      item: "admin/getRolesDetail"
    })
  },
  methods: {
    ...mapActions({
      loadRolesDetail: "admin/loadRolesDetail"
    }),
    returnParent() {
      this.$router.push({name: names.ROLES.LIST}).catch(() => {})
    },
    loadData(url=undefined){
      this.loadRolesDetail({
        url: url,
        id: this.$route.params.idRoles,
        finalizer: (data) => {
          this.page_title = "Список операций по роли: " + data.user.name
        }
      })
    }
  },
  created() {
    if (!admin.ADMIN.ALLOWED()){
      this.$router.push({name: names_core.MAIN}).catch(() => {})
    } else {
      this.loadData(undefined)
    }
  }
}
</script>

<style scoped>

</style>
